import {DragLayerMonitorProps} from '@minoru/react-dnd-treeview';
import React from 'react';
import {restData} from './TopicTreeMenu';

type Props = {
    monitorProps: DragLayerMonitorProps<restData>;
};
export const CustomDragPreview: React.FC<Props> = props => {
    const item = props?.monitorProps?.item;

    return (
        <div className={'customDragPreview'}>
            <div className={'icon'}>
                <span>a</span>
            </div>
            <div className={'label'}>{item.text}</div>
        </div>
    );
};
